module.exports = __webpack_public_path__ + "media/honey-icons/icon-record-c217a15b.svg";